import { GetDrawDownRepaymentScheduleCreditFacilityResponse } from '@iwoca/lapi-client/edge';
import { RootState } from '@iwProvider/configureStore';
import _ from 'lodash';

const getDrawdownRepaymentSchedule = (state: RootState) => {
    const creditFacilityRepaymentSchedule = _.get(
        state,
        'api.draw_down_repayment_schedule.data.schedule',
        null
    );
    //some parts of code is still using credit_facility_repayment_schedule, we need to phase it out.

    return creditFacilityRepaymentSchedule
        ? creditFacilityRepaymentSchedule
        : _.get(state, 'api.draw_down_repayment_schedule.data.schedule', []);
};

export const getDrawdownNextRepaymentAmount = (state: RootState) => {
    const repaymentSchedule = getDrawdownRepaymentSchedule(state);
    return _.get(repaymentSchedule, '[0].total');
};

export const getDrawdownNextRepaymentDate = (state: RootState) => {
    const repaymentSchedule = getDrawdownRepaymentSchedule(state);
    return _.get(repaymentSchedule, '[0].date');
};

export const calculateDrawdownTotalInterest = (
    repaymentSchedule: GetDrawDownRepaymentScheduleCreditFacilityResponse['data']['schedule']
) => {
    return repaymentSchedule.reduce(
        (totalInterest, repayment) => totalInterest + repayment.interest,
        0
    );
};
